module.exports = __webpack_public_path__ + "img/perplexity.10b28ca4.svg";